import { useState, useCallback } from 'react';

export const useSharePopup = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [shareText, setShareText] = useState('');

  const openSharePopup = useCallback((text: string) => {
    setShareText(text);
    setIsPopupOpen(true);
  }, []);

  const closeSharePopup = useCallback(() => {
    setIsPopupOpen(false);
  }, []);

  return { openSharePopup, closeSharePopup, isPopupOpen, shareText };
};
